import { RoleExpanded, UserRole } from '@/models/user-data.model';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-role-card',
  template: `
    <p-card class="p-1 mb-2 surface-border" *ngIf="role">
        <div class="flex justify-content-between align-items-center p-2 mb-1">
            <div class="flex flex-column">
                <span class="text-900 text-xl font-bold">{{role.RoleName}}</span>
                <span class="text-500 line-height-2" style="font-size: 1rem">{{role.officeName}}</span>
            </div>
            <p-button *ngIf="showRemove" pRipple icon="pi pi-trash" class="p-button-rounded" severity="danger" (onClick)="onRemoveRole(role.userRole)" />
        </div>
        <ul class="list-none mx-0 mb-1 mt-0 p-0 ml-1">
            <li class="flex align-items-start p-1" *ngFor="let permission of role.Access">
                
                <i class="bg-green-500 text-white border-circle border-1 p-1 surface-border pi pi-check mr-2" style="font-size: 1rem"></i>
                <span class="text-500 line-height-2" style="font-size: 1rem">{{renderPermDesc(permission.table, permission.perms)}}</span>
            </li>
        </ul>
</p-card>
    `,
    standalone: true,
  styles: `
    p-card .p-card-body {
  padding: 0px !important;
}`,
  imports: [CommonModule, ButtonModule, CardModule]
})
export class RoleCardComponent {
  @Input() role: RoleExpanded | null = null;
  @Input() showRemove: boolean = false;
  @Output() removeRole = new EventEmitter<UserRole>();

  camelCaseToTitleCase(camelCase: string): string {
    return camelCase
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
  }

  convertToList(perms: string[]): string {
    if (perms.length === 0) return '';
    if (perms.length === 1) return perms[0];
    return perms.slice(0, -1).join(', ') + ' & ' + perms[perms.length - 1];
  }

  onRemoveRole(role?: UserRole) {
    if (role) {
      this.removeRole.emit(role);
    }
  }

  renderPermDesc(table: string, perms: string[]) {
    const tableString = this.camelCaseToTitleCase(table);
    const permString = this.convertToList(perms);
    return `Can ${permString} ${tableString}`;
  }

}
